export enum RcfaComplianceEventName {
  userEntersRcfaCompliancePage = 'userEntersRcfaCompliancePage'
}

export type RcfaComplianceGeneralEvent = {
  name: RcfaComplianceEventName.userEntersRcfaCompliancePage
}
